import {Box} from '@mantine/core';
import type {FC, PropsWithChildren} from 'react';
import {GTAG_LOCATION} from '../../../config/constants/gtag';
import {useAuth} from '../../../core/usecases/auth/AuthContext';
import {SpHeaderBanner} from '../Banner/SpHeaderBanner';
import {GeneralFooter} from '../Footer/general';
import {EngineerHeaderContainer} from '../Header/Engineer/container';

type EngineerPageLayoutProps = PropsWithChildren<{
  hasFooter?: boolean;
  withSpBanner?: boolean;
}>;

export const EngineerPageLayout: FC<EngineerPageLayoutProps> = ({
  children,
  hasFooter = true,
  withSpBanner = true,
}) => {
  const {status} = useAuth();

  return (
    <div>
      <EngineerHeaderContainer />
      {withSpBanner && status === 'authenticated' && (
        <SpHeaderBanner
          location={GTAG_LOCATION.ENGINEER}
          className="w-full pc:hidden"
        />
      )}
      <main>
        <Box className="flex min-h-screen flex-col items-center bg-background-1 py-12 pc:py-32">
          {children}
        </Box>
      </main>
      {hasFooter && <GeneralFooter />}
    </div>
  );
};
